export default __webpack_public_path__ + "static/media/disabled.1cffb4d7.svg";